import { Component } from "react";
import Constants from "../utils/Constants";
import RoutePath from "../utils/routes/RoutePath";
import '@google/model-viewer/dist/model-viewer'
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Actions from "../redux/actions";
import { connect } from "react-redux";

class AddWard extends Component {
    componentDidMount() {
        this.props.getVendorSrmIpAgentList({ agentRoleFilter: 'ward_nurse' }, () => { });
    }

    render() {
        const { isEdit, error, message, handleSubmit, value, handleWardName, handleHeadNurse } = this.props
        const { getVendorRoomService = {} } = this.props
        const { vendorSrmIpAgentListData } = getVendorRoomService
        const headValue = value?.headUserId == null || value?.headUserId === ''
            ? 'ALL'
            : String(value.headUserId);
        return (
            <div className="content-part px-5 py-4">
                <div className="agent-details">
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Ward Name</p>
                                <input autoComplete="off" type="text" name='wardName' maxLength="100" className="form-control w-75" value={value?.wardName || ''} placeholder="Enter Ward Name" onChange={(e) => handleWardName(e)} />
                                {error?.wardName && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.wardName}</span>}
                            </div>
                        </div>
                    </div>
                    <div className="row m-0">
                        <div className="col-md-6" >
                            <div className="mt-3">
                                <p className="text-bold">Ward Nurse{isEdit ? '' : ' *'}</p>
                                <select name='headNurse' className="form-select w-75" value={headValue} onChange={(e) => handleHeadNurse(e)}>
                                    <option value={"ALL"}>
                                        {isEdit ? Constants.UNASSIGN_WARD_NURSE : Constants.SELECT_WARD_NURSE}
                                    </option>
                                    {
                                        vendorSrmIpAgentListData?.srmVendorSeviceAgents?.length > 0 && vendorSrmIpAgentListData?.srmVendorSeviceAgents?.map((o) => {
                                            return (
                                                <option key={o?.User?.id} value={o?.User?.id}>{o?.User?.fullName + ' (' + o?.User?.email + ')'}</option>
                                            )
                                        })
                                    }
                                </select>
                                {isEdit ? (
                                    <p className="text-muted mt-2" style={{ maxWidth: '75%' }}>{Constants.WARD_NURSE_OPTIONAL_EDIT}</p>
                                ) : null}
                                {error?.headUserId && <span style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.headUserId}</span>}
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 me-5 d-flex justify-content-start">
                        <button type="button" className="btn input-btn" onClick={() => this.props.history.push(RoutePath.VENDOR_WARD)}>{Constants.BACK}</button>
                        <button type="button" className="btn input-btn mx-3" onClick={() => handleSubmit()}>{isEdit ? Constants.UPDATE : Constants.CREATE}</button>
                    </div>
                </div>
            </div>
        )
    }
}
export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVendorSrmIpAgentList: Actions.getVendorSrmIpAgentList
})(AddWard));
